import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HeroSection } from '../../components/public/landing/HeroSection';
import { JourneySection } from '../../components/public/landing/JourneySection';
import { FeatureSection } from '../../components/public/landing/FeatureSection';
import { IntelligenceSection } from '../../components/public/landing/IntelligenceSection';
import { CtaSection } from '../../components/public/landing/CtaSection';

export const Landing = () => {
  const location = useLocation();

  // Handle hash navigation smoothly
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          const y = element.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 50);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <>
      <HeroSection />
      <JourneySection />
      <FeatureSection />
      <IntelligenceSection />
      <CtaSection />
    </>
  );
};